import clsx from 'clsx'

type LinearSlideAnimationProps = {
  className?: string
  isLoading?: boolean
}

export const LinearSlideAnimation = ({ isLoading, className }: LinearSlideAnimationProps) => (
  <div
    className={clsx(
      'h-0.5 w-full',
      isLoading
        ? 'animate-[horizontalBgSlide_1s_linear_infinite] bg-[linear-gradient(to_right,theme(colors.primary.DEFAULT),theme(colors.secondary.DEFAULT),theme(colors.destructive.DEFAULT),theme(colors.primary.DEFAULT))] bg-[length:200%]'
        : 'bg-transparent',
      className,
    )}
  />
)
